/** Pull a human-readable message from typical Laravel / API error shapes */
export const getApiErrorMessage = (err, fallback = "Something went wrong") => {
  const data = err?.response?.data;
  if (!data) return err?.message ?? fallback;

  if (typeof data.message === "string" && data.message.trim()) return data.message;

  const errors = data.errors ?? data.error;
  if (errors && typeof errors === "object") {
    const firstKey = Object.keys(errors)[0];
    const firstVal = errors[firstKey];
    if (Array.isArray(firstVal) && firstVal[0]) return String(firstVal[0]);
    if (typeof firstVal === "string") return firstVal;
  }

  return fallback;
};
